<template>
  <div>
    <Form ref="form" @submitedData="submitedData" />
  </div>
</template>

<script>
import Form from "./form.vue";
export default {
  components: { Form },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    async submitedData(data) {
      try {
        this.loadingWait();
        let post = await this.$api.post(
          "/api/v1/production/transfer/postall",
          data
        );

        if (post.data.status == "validation") {
          this.notifValidasi(post.data.message, true);
          this.loadingStop();
          return;
        }
        this.notifSuksesSimpan();
        this.loadingStop();
        this.$router.push("/production/transfer/" + this.$store.state.produksi);
      } catch (e) {
        console.log(e);
        this.loadingStop();
        this.notifError("Hubungi insys");
      }
    },
  },
  async mounted() {
    if (this.$route.params.id == undefined) {
      this.$router.push("/");
    } else {
      this.$checkParamsProduksi(this.$route.params.id);
      this.$store.commit("setProduksi", this.$route.params.id);
    }
  },
};
</script>
<style>
.tengah {
  text-align: center;
}
</style>
